


























import { TTabsItem } from '@/api/schema';
import VTabsHash from '@/components/VTabsHash.vue';
import { mapState } from 'vuex';

export enum EAutoclickerTabsKeys {
  AUTOCLICKER = 'autoclicker',
  WEB_AI_STREAMER_PROFILES = 'web_ai_streamer_profiles',
  GAMES_FOR_AUTOCLICKER = 'games-for-autoclicker',
  JOB_MANAGEMENT = 'job-management'
}

export default {
  name: 'CopyStakeAiStreamerTabsView',
  components: {
    VTabsHash,
    CopyStakeAutoclickerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/AiStreamers/CopyStakeAutoclickerTab.vue'
      ),
    CopyStakeWebAiStreamerProfilesTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfilesTab.vue'
      ),
    CopyStakeGamesForAutoclickerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/GamesForAutoclicker/CopyStakeGamesForAutoclickerTab.vue'
      ),
    CopyStakeJobManagementTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/JobManagement/CopyStakeJobManagementTab.vue'
      )
  },
  data(): any {
    return {
      currentTab: 0
    };
  },
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    tabs(): TTabsItem[] {
      return [
        {
          id: EAutoclickerTabsKeys.AUTOCLICKER,
          text: 'Autoclicker',
          component: 'CopyStakeAutoclickerTab',
          visible: true
        },
        {
          id: EAutoclickerTabsKeys.WEB_AI_STREAMER_PROFILES,
          text: 'Streamer Profiles',
          component: 'CopyStakeWebAiStreamerProfilesTab',
          visible: this.isSuperAdmin
        },
        {
          id: EAutoclickerTabsKeys.GAMES_FOR_AUTOCLICKER,
          text: 'Games for Autoclicker',
          component: 'CopyStakeGamesForAutoclickerTab',
          visible: this.isSuperAdmin
        },
        {
          id: EAutoclickerTabsKeys.JOB_MANAGEMENT,
          text: 'Job Management',
          component: 'CopyStakeJobManagementTab',
          visible: true
        }
      ].filter(({ visible }) => visible);
    }
  }
};
